import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SkeletonService {
    private resizeObserver: ResizeObserver | null = null;

    setupResizeObserver(callback: () => void): void {
        if (!this.resizeObserver) {
            this.resizeObserver = new ResizeObserver(callback);
            this.resizeObserver.observe(document.body);
        }
    }

    cleanupResizeObserver(): void {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
    }

    calculateSkeletonCount(itemHeight: number, gap: number, padding: number, extraSpace: number = 10): number {
        const viewportHeight = window.innerHeight;
        const availableHeight = viewportHeight - extraSpace;
        return Math.max(1, Math.floor((availableHeight - padding) / (itemHeight + gap)));
    }

    getSkeletonArray(count: number): number[] {
        return Array(count).fill(0);
    }
}